import script from "./2FA.vue?vue&type=script&setup=true&lang=js"
export * from "./2FA.vue?vue&type=script&setup=true&lang=js"

import "./2FA.vue?vue&type=style&index=0&id=21495fff&lang=css"

const __exports__ = script;

export default __exports__